/**
 * MessageList
 *
 * The bubble transcript shared by IntakeThread (clarifying questions) and
 * NegotiationThread (breakdown negotiation) — same markup, two different
 * conversations feeding it.
 */

import { Component, For, Show } from "solid-js";
import type { Message } from "../../api/types";

export interface MessageListProps {
  messages: Message[];
  /** Message awaiting a reply — echoed before the backend has persisted it */
  pending: string | null;
  /** True while the AI is working */
  busy: boolean;
}

export const MessageList: Component<MessageListProps> = (props) => (
  <ol class="flex flex-col gap-4">
    <For each={props.messages}>
      {(message) => (
        <li
          class={
            "flex " +
            (message.role === "user" ? "justify-end" : "justify-start")
          }
        >
          <div
            class={
              "max-w-[85%] rounded-md px-4 py-3 text-sm whitespace-pre-wrap " +
              (message.role === "user"
                ? "bg-ink text-paper"
                : "bg-surface border border-line text-ink")
            }
          >
            {message.content}
          </div>
        </li>
      )}
    </For>

    <Show when={props.pending}>
      {(text) => (
        <li class="flex justify-end">
          <div class="max-w-[85%] rounded-md bg-ink/70 px-4 py-3 text-sm text-paper whitespace-pre-wrap">
            {text()}
          </div>
        </li>
      )}
    </Show>

    <Show when={props.busy}>
      <li class="flex justify-start" role="status">
        <div class="rounded-md border border-line bg-surface px-4 py-3 text-sm text-ink-3">
          Thinking…
        </div>
      </li>
    </Show>
  </ol>
);

export default MessageList;
